const ORIGIN = '*';

function send(type: string, data?: Record<string, unknown>): void {
  if (window.parent === window) return;
  window.parent.postMessage({ type, ...data }, ORIGIN);
}

export function sendReady(height: number, maxWidth?: number): void {
  send('meeteor:ready', { height, ...(maxWidth != null && { maxWidth }) });
}

export function sendResize(height: number, maxWidth?: number): void {
  send('meeteor:resize', { height, ...(maxWidth != null && { maxWidth }) });
}

export function sendPurchaseComplete(data: {
  sale_id: string;
  tickets: unknown[];
}): void {
  send('meeteor:purchase_complete', { data });
}

export function sendError(code: string, message: string): void {
  send('meeteor:error', { error: { code, message } });
}

export function sendClose(): void {
  send('meeteor:close');
}

export function sendOccurrenceEventNavigate(eventId: string, dateIso: string): void {
  if (window.parent === window) return;
  send('meeteor:occurrence_event', { eventId, dateIso });
}

export function listenForParentMessages(
  onSetPromo: (code: string) => void,
  onSetTheme: (theme: Record<string, unknown>) => void,
  onSetContact?: (contact: { name?: string; email?: string; phone?: string }) => void,
): () => void {
  const handler = (e: MessageEvent) => {
    if (!e.data?.type) return;
    switch (e.data.type) {
      case 'meeteor:set_promo':
        if (e.data.code) onSetPromo(e.data.code);
        break;
      case 'meeteor:set_theme':
        if (e.data.theme) onSetTheme(e.data.theme);
        break;
      case 'meeteor:set_contact':
        if (e.data.contact && onSetContact) onSetContact(e.data.contact);
        break;
    }
  };
  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
}
